<template>
  <div>
    <Header />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="Home">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Eligibility Evaluation Process
          </li>
        </ol>
      </div>
    </nav>

    <div class="main form qualificationForm">
      <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();">
        :::
      </a>

      <div class="container">
        <!-- Loading State -->
        <div v-if="loading" class="box">
          <div class="title">
            <h2>Loading...</h2>
          </div>
          <div class="bg">
            <div class="form-group full" style="padding: 20px; text-align: center;">
              Please wait while we load the eligibility information...
            </div>
          </div>
        </div>

        <!-- Error State -->
        <div v-else-if="error" class="box">
          <div class="title">
            <h2>Error</h2>
          </div>
          <div class="bg">
            <div class="form-group full" style="padding: 20px; color: red; text-align: center;">
              {{ errorMessage }}
            </div>
          </div>
        </div>

        <!-- Eligibility Check Form -->
        <div v-else class="box">
          <div class="title">
            <h2>Eligibility Evaluation Process</h2>
          </div>

          <div class="bg">
            <!-- <div class="title_box">
              <h3>Please select the item that describes you</h3>
            </div> -->

            <template v-if="currentQuestion && currentQuestion.type === 'answer'">
              <div class="eligibility_box" style="max-width: none;">
                <!-- <img class="" src="img/login_img.svg" alt="" /> -->
                <div class="text_box" id="">
                  <div class="title_box description">
                    <h3>{{ currentQuestion.title }}</h3>
                  </div>
                  <div v-if="currentQuestion.answerContent" v-html="currentQuestion.answerContent">
                  </div>
                  <div class="btn_box" style="display: flex; justify-content: space-between;">
                    <div>
                      <img class="" src="img/login_img.svg" alt="" />
                      <button class="btn" @click="handleGoBack" style="">
                        Previous
                      </button>
                      <button class="btn" @click="handleReset" style="">
                        Reset
                      </button>
                    </div>
                    <button class="btn"
                      v-if="currentQuestion && currentQuestion.type === 'answer' && currentQuestion.allow === 'yes'"
                      @click="handleStartApplication">
                      Start Application
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- 當前問題 -->
              <div v-if="currentQuestion && currentQuestion.type === 'options'"
                class="form-group check_block full describes_box">
                <label class="title_box"
                  style="font-weight: 600; font-size: 16px; margin-bottom: 15px; display: block;">
                  <h3>{{ currentQuestion.title }} :</h3>
                </label>
                <div class="option_group">
                  <div v-for="option in currentQuestion.options" :key="option.id" class="option_item"
                    @click="handleOptionSelect(option)">
                    <span class="play_icon">▶</span>
                    <span class="option_text">{{ getOptionText(option) }}</span>
                  </div>
                </div>
              </div>
              <!-- 最終答案顯示 -->
              <div v-if="currentQuestion && currentQuestion.type === 'answer'" class="form-group check_block full">
                <!-- 顯示答案內容 (HTML) -->
                <div v-if="currentQuestion.answerContent" v-html="currentQuestion.answerContent">
                </div>
              </div>
              <!-- Previous 和 Reset 按鈕 (當有選擇歷史時顯示) -->
              <div v-if="questionHistory.length > 0 && currentQuestion" class="btn_box"
                style="width: 100%; text-align: left; margin-bottom: 10px; margin-top: 10px;">
                <button class="btn" @click="handleGoBack" style="">
                  Previous
                </button>
                <button class="btn reset_btn" @click="handleReset" style="">
                  Reset
                </button>
                <button class="btn"
                  v-if="currentQuestion && currentQuestion.type === 'answer' && currentQuestion.allow === 'yes'"
                  @click="handleStartApplication">
                  Start Application
                </button>
              </div>
              <!-- 已選擇的選項顯示 (當有選擇歷史時) -->
              <div v-if="questionHistory.length > 0 && currentQuestion" class="form-group check_block full">
                <p class="selected_p" style="font-weight: 600; margin-bottom: 10px;">Selected :</p>
                <div v-for="(historyItem, index) in questionHistory" :key="index" class="selected_item">
                  <span class="check_icon"></span>
                  <span>{{ historyItem.title }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import applyStudentService from "@/services/applyStudent.js";
import authService from '@/services/auth';

export default {
  name: "QualificationForm",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      loading: true,
      error: false,
      errorMessage: "",

      // 所有問題資料
      allQuestions: [],

      // 問題 ID 到問題物件的映射
      questionMap: {},

      // 當前問題
      currentQuestion: null,

      // 問題歷史記錄 (已回答的問題)
      questionHistory: [],
    };
  },

  async mounted() {
    window.scrollTo(0, 0);

    // 載入資格審核資料
    await this.fetchEligibilityData();
  },

  methods: {
    /**
     * 取得資格審核資料
     */
    async fetchEligibilityData() {
      this.loading = true;
      this.error = false;

      try {
        const result = await applyStudentService.getActiveApplyEligibility();

        if (result.success && result.data && result.data.questions) {
          this.allQuestions = result.data.questions;

          // 建立問題 ID 到問題物件的映射
          this.questionMap = {};
          this.allQuestions.forEach(q => {
            this.questionMap[q.id] = q;
          });

          // 收集所有被引用的問題 ID (作為子問題)
          const referencedQuestionIds = new Set();
          this.allQuestions.forEach(q => {
            if (q.options && q.options.length > 0) {
              q.options.forEach(opt => {
                if (opt.nextQuestionId) {
                  referencedQuestionIds.add(opt.nextQuestionId);
                }
              });
            }
          });

          // 找出第一層問題 (沒有被任何其他問題引用的問題)
          const rootQuestions = this.allQuestions
            .filter(q => !referencedQuestionIds.has(q.id))
            .sort((a, b) => a.sortOrder - b.sortOrder);

          if (rootQuestions.length > 0) {
            // 將第一層問題作為一個虛擬問題的選項
            this.currentQuestion = {
              id: 'root',
              title: 'Please select the item that describes you',
              type: 'options',
              options: rootQuestions,
              sortOrder: 0
            };
          } else {
            this.error = true;
            this.errorMessage = "No eligibility questions found.";
          }
        } else {
          this.error = true;
          this.errorMessage = result.message || "Failed to load eligibility data.";
        }
      } catch (err) {
        this.error = true;
        this.errorMessage = "An unexpected error occurred. Please try again later.";
        console.error("Error fetching eligibility data:", err);
      } finally {
        this.loading = false;
      }
    },

    /**
     * 取得選項顯示文字
     * 如果選項有 nextQuestionId,則從對應問題的 title 取得
     * 否則使用選項本身的 title
     */
    getOptionText(option) {
      // 如果選項有 nextQuestionId,從對應的問題取得標題
      if (option.nextQuestionId && this.questionMap[option.nextQuestionId]) {
        return this.questionMap[option.nextQuestionId].title;
      }
      // 如果是根問題的選項(直接是問題物件)
      if (option.title) {
        return option.title;
      }
      // 備用:使用選項的 text
      return option.text || '';
    },

    /**
     * 處理選項選擇
     */
    handleOptionSelect(selectedOption) {
      // 取得選項顯示的文字
      const optionText = this.getOptionText(selectedOption);

      // 記錄選擇到歷史 (只記錄選擇的選項文字,不記錄問題)
      this.questionHistory.push({
        title: optionText,
        id: selectedOption.id,
        previousQuestion: this.currentQuestion  // 保存上一個問題,用於返回
      });

      // 如果 selectedOption 是一個包含 nextQuestionId 的選項物件
      if (selectedOption.nextQuestionId) {
        // 根據 nextQuestionId 找到下一個問題
        const nextQuestion = this.questionMap[selectedOption.nextQuestionId];

        if (nextQuestion) {
          this.currentQuestion = nextQuestion;
        } else {
          console.error('Next question not found:', selectedOption.nextQuestionId);
        }
      }
      // 如果 selectedOption 本身就是一個問題物件 (從根選項選擇的情況)
      else if (selectedOption.type) {
        // 如果是 answer 類型,直接顯示答案
        if (selectedOption.type === 'answer') {
          this.currentQuestion = selectedOption;
        }
        // 如果是 options 類型,顯示這個問題
        else if (selectedOption.type === 'options') {
          this.currentQuestion = selectedOption;
        }
      }

      // 滾動到頂部
      window.scrollTo(0, 0);
    },

    /**
     * 返回上一步
     */
    handleGoBack() {
      if (this.questionHistory.length > 0) {
        // 取得最後一個歷史記錄的上一個問題
        const lastHistory = this.questionHistory[this.questionHistory.length - 1];
        this.currentQuestion = lastHistory.previousQuestion;

        // 移除最後一個歷史記錄
        this.questionHistory.pop();
      }

      // 滾動到頂部
      window.scrollTo(0, 0);
    },

    /**
     * 重設到初始狀態
     */
    handleReset() {
      this.questionHistory = [];
      this.resetToRootQuestion();

      // 滾動到頂部
      window.scrollTo(0, 0);
    },

    /**
     * 重設到根問題
     */
    resetToRootQuestion() {
      // 收集所有被引用的問題 ID
      const referencedQuestionIds = new Set();
      this.allQuestions.forEach(q => {
        if (q.options && q.options.length > 0) {
          q.options.forEach(opt => {
            if (opt.nextQuestionId) {
              referencedQuestionIds.add(opt.nextQuestionId);
            }
          });
        }
      });

      // 找出第一層問題
      const rootQuestions = this.allQuestions
        .filter(q => !referencedQuestionIds.has(q.id))
        .sort((a, b) => a.sortOrder - b.sortOrder);

      this.currentQuestion = {
        id: 'root',
        title: 'Please select the item that describes you',
        type: 'options',
        options: rootQuestions,
        sortOrder: 0
      };
    },

    /**
     * 開始申請
     */
    async handleStartApplication() {
      await authService.updateReview(true);
      // 導向 Terms 頁面
      this.$router.push("/Terms").then(() => {
        window.scrollTo(0, 0);
      });
    },
  },
};
</script>

<style scoped>
/* 選項群組樣式 */
.option_group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 選項項目樣式 */
.option_item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 5px 0;
}

.option_item:hover {
  background: #f8f9fa;
  border-color: #4d167d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 播放圖示 */
.play_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #4d167d;
  color: #fff;
  border-radius: 3px;
  margin-right: 12px;
  font-size: 12px;
  flex-shrink: 0;
}

/* 選項文字 */
.option_text {
  flex: 1;
  font-size: 1rem;
  line-height: 1.5;
}

/* 已選擇項目樣式 */
.selected_item {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  border-bottom: 1px dotted #AC9CB9;
}

/* 勾選圖示 */
.check_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  color: #fff;
  border-radius: 50%;
  margin-right: 12px;
  font-size: 12px;
  flex-shrink: 0;
}

/* 按鈕樣式調整 */
.btn_box .btn {
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.btn_box .btn:hover {
  transform: translateY(-1px);
}

.btn_box .btn i {
  margin-right: 5px;
}

/* 答案內容樣式 */
.answer_content {
  line-height: 1.8;
}

.answer_content a {
  color: #4d167d;
  text-decoration: underline;
}

.answer_content a:hover {
  color: #6d2a9d;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .option_item {
    padding: 10px 12px;
  }

  .option_text {
    font-size: 14px;
  }

  .btn_box .btn {
    padding: 6px 15px;
    font-size: 13px;
  }
}
</style>
